export default class DateFormatter {
  /**
   * DateオブジェクトをyyyyMMddHHmmssフォーマットの文字列で返す
   * @param {date} date
   */
  format (date) {
    date.setTime(date.getTime() + 1000 * 60 * 60 * 9) // JSTに変換
    const res = `${date.getUTCFullYear()}${this.__padZero(date.getUTCMonth() + 1)}${this.__padZero(date.getUTCDate())}${this.__padZero(date.getUTCHours())}${this.__padZero(date.getUTCMinutes())}${this.__padZero(date.getUTCSeconds())}`
    console.log(`UTC TIME => ${res}`)
    return res
  }

  __padZero (num) {
    if (num < 10) {
      return `0${num}`
    } else {
      return `${num}`
    }
  }
}
